import CardHeader, { CardHeaderProps } from "../../components/Header";
import CardCollapsibleToggle, { CardCollapsibleToggleProps } from "./Toggle";

type CardCollapsibleHeaderProps = CardHeaderProps & CardCollapsibleToggleProps;
const CardCollapsibleHeader = ({
  align,
  children,
  suffix,
  titleSuffix,
  titleHtmlFor,
  prefix,
  titleTag,
  titleVariant,
  className,
  ...cardCollapsibleToggleProps
}: CardCollapsibleHeaderProps) => {
  return (
    <CardHeader
      align={align}
      prefix={prefix || <CardCollapsibleToggle {...cardCollapsibleToggleProps} />}
      suffix={suffix}
      titleSuffix={titleSuffix}
      titleHtmlFor={titleHtmlFor}
      titleTag={titleTag}
      titleVariant={titleVariant}
      className={className}
    >
      {children}
    </CardHeader>
  );
};

CardCollapsibleHeader.displayName = "DS.Card.Collapsible.Header";

export default CardCollapsibleHeader;
